module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform",
    attrs: {
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "20%",
      "display": "flex"
    },
    attrs: {
      "label": "关 键 字："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入客户手机号或订单号",
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.filters, "orderNo", $$v)
      },
      expression: "filters.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "20%",
      "display": "flex"
    },
    attrs: {
      "label": "品 类："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择品类",
      "filterable": ""
    },
    on: {
      "change": _vm.getbrandarr
    },
    model: {
      value: (_vm.filters.brandTypeId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "brandTypeId", $$v)
      },
      expression: "filters.brandTypeId"
    }
  }, _vm._l((_vm.brandTypearr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "20%",
      "display": "flex"
    },
    attrs: {
      "label": "品 牌："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择品牌",
      "filterable": ""
    },
    model: {
      value: (_vm.filters.brandId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "brandId", $$v)
      },
      expression: "filters.brandId"
    }
  }, _vm._l((_vm.brandarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "20%",
      "display": "flex"
    },
    attrs: {
      "label": "状   态："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择状态",
      "filterable": ""
    },
    model: {
      value: (_vm.filters.biddingStatusId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "biddingStatusId", $$v)
      },
      expression: "filters.biddingStatusId"
    }
  }, _vm._l((_vm.chooseStateList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "68px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.orderNo,
            "label": scope.row.orderNo
          }
        }, [_vm._v(_vm._s(scope.row.orderNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户昵称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.userName,
            "label": scope.row.userName
          }
        }, [_vm._v(_vm._s(scope.row.userName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手机号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.userPhone,
            "label": scope.row.userPhone
          }
        }, [_vm._v(_vm._s(scope.row.userPhone))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品类",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.goodsBrandTypeName,
            "label": scope.row.goodsBrandTypeName
          }
        }, [_vm._v("\r\n              " + _vm._s(scope.row.goodsBrandTypeName) + "\r\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.brandName,
            "label": scope.row.brandName
          }
        }, [_vm._v(_vm._s(scope.row.brandName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.goodsName,
            "label": scope.row.goodsName
          }
        }, [_vm._v(_vm._s(scope.row.goodsName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "消费积分",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.integral,
            "label": scope.row.integral
          }
        }, [_vm._v(_vm._s(scope.row.integral))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.stateName,
            "label": scope.row.stateName
          }
        }, [_vm._v(_vm._s(scope.row.stateName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type != 3) ? _c('span', {
          staticClass: "handle",
          staticStyle: {
            "margin-right": "5px"
          },
          on: {
            "click": function($event) {
              return _vm.seeOrder(scope.row.id, scope.row.state)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v("查看\r\n            ")]) : _vm._e(), _vm._v(" "), (scope.row.state == 1) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.deliverGoodsFn(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-truck"
        }), _vm._v("发货\r\n            ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "visible": _vm.orderDetails,
      "show-close": false,
      "size": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.orderDetails = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('ul', {
          staticClass: "drawer_title"
        }, [_c('li', [_vm._v("订单详情")]), _vm._v(" "), _c('li', [_c('el-button', {
          staticStyle: {
            "margin-top": "-10px"
          },
          attrs: {
            "type": "danger"
          },
          on: {
            "click": _vm.cancelDrawer
          }
        }, [_vm._v("关 闭")])], 1)])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "drawer_div"
  }, [_c('div', {
    staticClass: "drawerDiv deliverDetails"
  }, [_c('p', [_vm._v("用户信息")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\r\n            换购人："), _c('span', [_vm._v(_vm._s(_vm.integralDet.userName))])]), _vm._v(" "), _c('li', [_vm._v("\r\n            手机号："), _c('span', [_vm._v(_vm._s(_vm.integralDet.userPhone))])]), _vm._v(" "), (_vm.integralDet.deliveryMode == 1 && _vm.integralDet.type == 1) ? _c('li', [_vm._v("\r\n            收货人姓名："), _c('span', [_vm._v(_vm._s(_vm.integralDet.consigneeName))])]) : _vm._e(), _vm._v(" "), (_vm.integralDet.deliveryMode == 1 && _vm.integralDet.type == 1) ? _c('li', [_vm._v("\r\n            手机号："), _c('span', [_vm._v(_vm._s(_vm.integralDet.consigneePhone))])]) : _vm._e(), _vm._v(" "), (_vm.integralDet.deliveryMode == 1 && _vm.integralDet.type == 1) ? _c('li', {
    staticClass: "maxWidth"
  }, [_vm._v("\r\n            收货地址："), _c('span', [_vm._v(_vm._s(_vm.integralDet.consigneeAddress))])]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("商品信息")]), _vm._v(" "), _c('ul', [_c('div', {
    staticClass: "leftImgRigText"
  }, [(_vm.integralDet.type == 1) ? _c('div', {
    staticClass: "imgBox"
  }, [_c('img', {
    attrs: {
      "src": _vm.integralDet.imgUrl,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "drawerDiv"
  }, [_c('ul', [_c('li', [_vm._v("商品名称："), _c('span', [_vm._v(_vm._s(_vm.integralDet.goodsName))])]), _vm._v(" "), _c('li', [_vm._v("品类："), _c('span', [_vm._v(_vm._s(_vm.integralDet.goodsBrandTypeName))])]), _vm._v(" "), _c('li', [_vm._v("品牌："), _c('span', [_vm._v(_vm._s(_vm.integralDet.brandName))])])])])])]), _vm._v(" "), _c('p', [_vm._v("订单信息")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "maxWidth"
  }, [_vm._v("订单号："), _c('span', [_vm._v(_vm._s(_vm.integralDet.orderNo))])]), _vm._v(" "), _c('li', [_vm._v("订单状态："), _c('span', [_vm._v(_vm._s(_vm.integralDet.stateName))])]), _vm._v(" "), (_vm.integralDet.deliveryMode == 1 && _vm.integralDet.type == 1) ? _c('li', [_vm._v("\r\n            运费："), _c('span', [_vm._v(_vm._s(_vm.integralDet.freight) + "元")])]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("\r\n            订单总价："), _c('span', [_vm._v(_vm._s(_vm.integralDet.price) + "元")])]), _vm._v(" "), _c('li', [_vm._v("消费积分："), _c('span', [_vm._v(_vm._s(_vm.integralDet.integral))])]), _vm._v(" "), _c('li', {
    staticClass: "maxWidth"
  }, [_vm._v("换购时间："), _c('span', [_vm._v(_vm._s(_vm.integralDet.cTime))])]), _vm._v(" "), (_vm.integralDet.deliveryMode == 1 && _vm.integralDet.type == 1 && _vm.detStateId > 2) ? _c('li', {
    staticClass: "maxWidth"
  }, [_vm._v("\r\n            发货时间："), _c('span', [_vm._v(_vm._s(_vm.integralDet.expressTime))])]) : _vm._e(), _vm._v(" "), (_vm.integralDet.deliveryMode == 1 && _vm.integralDet.type == 1) ? _c('li', {
    staticClass: "maxWidth"
  }, [_vm._v("\r\n            物流信息：\r\n            "), (_vm.detStateId == 1) ? _c('span', [_vm._v("未发货，无物流信息")]) : _c('span', [_vm._v(_vm._s(_vm.integralDet.expressName) + "，单号：" + _vm._s(_vm.integralDet.expressOrderNo))])]) : _vm._e(), _vm._v(" "), (_vm.detStateId >= 4 && _vm.integralDet.type == 1) ? _c('li', {
    staticClass: "maxWidth"
  }, [_vm._v("完成时间："), _c('span', [_vm._v(_vm._s(_vm.integralDet.completeTime))])]) : _vm._e()])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "add_order_cancle",
    attrs: {
      "title": "物流发货",
      "visible": _vm.deliverGoodsSettings,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.deliverGoodsSettings = $event
      },
      "close": function($event) {
        return _vm.canceldeliverGoodsFun()
      }
    }
  }, [_c('el-form', {
    ref: "deliverGoods",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.deliverGoods,
      "label-width": "80px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物流公司:",
      "prop": "groupModeId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择物流公司"
    },
    model: {
      value: (_vm.deliverGoods.groupModeId),
      callback: function($$v) {
        _vm.$set(_vm.deliverGoods, "groupModeId", $$v)
      },
      expression: "deliverGoods.groupModeId"
    }
  }, _vm._l((_vm.logisticsCompanyList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Name,
        "label": item.Name
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物流单号:",
      "prop": "groupNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入物流单号",
      "minlength": "5",
      "maxlength": "30"
    },
    model: {
      value: (_vm.deliverGoods.groupNumber),
      callback: function($$v) {
        _vm.$set(_vm.deliverGoods, "groupNumber", $$v)
      },
      expression: "deliverGoods.groupNumber"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center",
      "margin-top": "25px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.canceldeliverGoodsFun()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.editDeliverGoodsSubmit()
      }
    }
  }, [_vm._v("发货")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("兑换记录")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60014dcc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PointsMall/ExchangeRecords.vue
// module id = 1698
// module chunks = 3